import React from "react";
import AreaChart from "./AreaChart";

const Demo = () => {
	return (
		<div>
			<AreaChart />
		</div>
	);
};

export default Demo;
